<template>
  <FileUploadSlot @update:file="uploadFile">
    <template v-slot:activator="{ on }">
      <v-expansion-panels>
        <v-expansion-panel v-on="on" class="rounded-4" readonly :disabled="loading">
          <v-expansion-panel-header
            ripple
            style="height: 64px"
            class="font--m-3"
            :class="{ loading }"
          >
            <div>
              <h3 class="font--m-3">{{ loading ? '서류를 제출중입니다' : '증빙 서류 제출' }}</h3>
              <p class="mb-0 font--m-7 color--nice-grey" style="margin-top: 3px">
                이미지, pdf 형식으로 제출해주세요.
              </p>
            </div>
            <template v-slot:actions>
              <v-icon v-if="!loading"> mdi-file-upload-outline </v-icon>
              <v-progress-circular
                v-else
                indeterminate
                color="grey"
                size="21"
                width="2"
              ></v-progress-circular>
            </template>
          </v-expansion-panel-header>
        </v-expansion-panel>
      </v-expansion-panels>
    </template>
  </FileUploadSlot>
</template>

<script>
import RequestFileUploadMixin from './RequestFileUploadMixin.js'

export default {
  mixins: [RequestFileUploadMixin],
}
</script>

<style lang="scss" scoped>
::v-deep .v-expansion-panel-header .v-expansion-panel-header__icon {
  transform-origin: none;
  display: block !important;
}
</style>
